// components/Ads/InFeedAd.tsx
import React from 'react';
import AdUnit from './AdUnit';
import { getAdSlot } from './adConfig';

interface InFeedAdProps {
  compact?: boolean;
  testMode?: boolean;
  className?: string;
}

const InFeedAd: React.FC<InFeedAdProps> = ({ 
  compact = false, 
  testMode = false,
  className = ''
}) => {
  const slot = getAdSlot('infeed');
  const format = compact ? 'rectangle' : 'auto';

  return (
    <div className={`my-4 ${className}`}>
      <div className="max-w-4xl mx-auto">
        {/* Label */}
        <div className="text-xs text-gray-500 mb-2 text-center">
          <span className="inline-flex items-center">
            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
            Advertisement
          </span>
        </div>
        
        {/* Ad Unit */}
        <div className="flex justify-center">
          <AdUnit 
            slot={slot} 
            format={format}
            style={{
              border: testMode ? '2px dashed #f59e0b' : undefined
            }}
          />
        </div>
        
        {/* Test Mode Indicator */}
        {testMode && (
          <div className="text-xs text-amber-600 mt-1 text-center">
            Test Mode - Ad slot: {slot}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(InFeedAd);
